import { Drawer, Stack, TextField } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';


function Server({ open, rowServer, onClose }: { open: boolean; rowServer: any, onClose: any }) {
    const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
    
    React.useEffect(() => {
        SetOpenDrawer(open);
    }, [open]);

    return (
        <Box>
            <Drawer
                PaperProps={{ style: { width: 'auto' } }}
                anchor="right"
                open={openDrawer}
                onClose={() => onClose(0)}
                variant={'temporary'}
            >
                <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
                    <Box style={{ width: "100%" }}>
                        <Box>
                            <TextField
                                required
                                id="outlined-required"
                                label="PublicIP"
                                value={rowServer.publicIp}
                                style={{ width: "300px" }}
                            />
                        </Box>
                        <Box style={{ marginTop: "10px" }}>
                            <TextField
                                required
                                id="outlined-required"
                                label="DNS"
                                value={rowServer.dns}
                                style={{ width: "300px" }}
                            />
                        </Box>
                        <Box style={{ marginTop: "10px" }}>
                            <TextField
                                required
                                id="outlined-required"
                                label="Spooler Status"
                                value={rowServer.spoolerStatus}
                                style={{ width: "300px" }}
                            />
                        </Box>
                    </Box>
                    
                </Box>
            </Drawer>
        </Box>
    );
}
export default Server